requirejs.config({
  paths: {
    backbone: '../bower_components/backbone/backbone',
    lodash: '../bower_components/lodash/lodash.min',
    Quagga: '../bower_components/quagga/dist/quagga',
    jquery: '../bower_components/jquery/dist/jquery',
    text: '../bower_components/text/text',
    selectize: '../bower_components/selectize/dist/js/standalone/selectize.min',
    polyglot: '../bower_components/polyglot/build/polyglot.min',
    pikaday: '../bower_components/pikaday/pikaday',
    moment: '../bower_components/moment/moment',
    URIjs: '../bower_components/urijs/src',
    dropzone: '../bower_components/dropzone/dist/min/dropzone-amd-module.min',
    session: 'modules/session/session_model'
  },

  shim: {
    pikaday: {
      deps: ['moment']
    },
    polyglot: {
      exports: 'Polyglot'
    }
  },
  map: {
    '*': {
      underscore: 'lodash', // trick backbone to use lodash
      _: 'lodash'
    }
  }
});

require([
  'backbone',
  'jquery',
  '_',
  'router',
  'languages/lang',
  'modules/user/user_model',
  'session',
  'selectize'
], function (Backbone, $, _, Router, Lang, user, session, selectize) {
  'use strict';

  var App = {};

  selectize.define('freetext_search', function (options) {
    var self = this;

    options.text = options.text || function (option) {
        return option[this.settings.labelField];
    };

    this.onBlur = (function (e) {
        var original = self.onBlur;

        return function (e) {
            // Capture the current input value
            var $input = this.$control_input;
            var inputValue = $input.val();
            var change = this.getValue();

            // Do the default actions, which will clear the value
            original.apply(this, [e]);

            // Set the value back
            this.setTextboxValue(inputValue);

            // Add input value to change if it is not empty.
            if (inputValue.trim() != '') {
              change+=' '+inputValue;
            }

            //Trigger change event
            this.trigger('change', change);
        };
    })();

    this.onKeyDown = (function (e) {
      var original = self.onKeyDown;

      return function (e) {
        // Check if user pressed Enter
        if (e.keyCode === 13) {
          var $input = this.$control_input;
          var inputValue = $input.val();
          var change = this.getValue();

          // Add input value to change if it is not empty.
          if (inputValue.trim() != '') {
            change+=' '+inputValue;
          }

          // Trigger change event
          this.trigger('change', change);
          e.preventDefault();
        }
        return original.apply(this, arguments);
      };
    })();

  });

  App.lang = new Lang('sv');
  App.user = user;
  App.session = session;

  session.set('lang', App.lang);
  session.set('user', App.user);
  session.set('location_id', false);
  session.set('apiUrl', window.apiUrl);
  session.set('apiBaseUrl', window.apiBaseUrl);
  session.set('oidc', window.oidc);
  session.set('oidcReturnUrl', window.oidcReturnUrl);

  $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    options.xhrFields = {
      withCredentials: true
    };
  });

  $(document).on('scroll', function () {
    sessionStorage.setItem('scrollTopPosition_' + document.location.pathname, $(window).scrollTop());
  });

  _.mixin({
    'media_url': function (key, opts) {

      if (key) {
        return (key.substring(0, 4) === 'http' || key.substring(0, 2) === '//') ? key : window.apiBaseUrl + key;
      }

      return '';
    }
  });

  $.when(App.lang).then(function (lang) {
    App.router = new Router({app: App});
  }, function (err) {
    console.log('err', err);
  });

});


define("app", function(){});

